import React from "react";
import { Select as BaseSelect } from "../../Select";
import { SelectProps } from "../types";
import { withFormField } from "./withFormField";

const BaseSelectComponent = React.forwardRef<HTMLDivElement, SelectProps>(
  props => {
    const { options, onChange, readOnly, value, disabled, mode, ...rest } =
      props;

    const onSelect = (selectedValues: string | string[]) => {
      if (readOnly) return;
      if (onChange) {
        onChange({
          target: {
            value: selectedValues,
          },
        } as unknown as React.ChangeEvent<HTMLDivElement>);
      }
    };

    return (
      <BaseSelect
        options={options}
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        {...rest}
        onSelect={onSelect}
        mode={mode}
      />
    );
  },
);

BaseSelectComponent.displayName = "BaseSelectComponent";

export const Select = withFormField<SelectProps>(BaseSelectComponent);
